<template>
  <div class="contenedor">
    <div class="panelesConfiguracion">
      <b-card class="panelConfiguracionA">
        <div class="contenidoPanelConfiguracionA">
          <div class="text-center">
            <label for="visibleHAppsElements">hApps Elements</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.hAppsElements"
              name="visibleHAppsElements"
              :checked="visibleCards.hAppsElements"
            />
          </div>
          <div class="text-center">
            <label for="hAppProperties">hApp properties</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.hAppProperties"
              name="hAppProperties"
              :checked="visibleCards.hAppProperties"
            />
          </div>
          <div class="text-center">
            <label for="hObjectProperties">hObject properties</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.hObjectProperties"
              name="hObjectProperties"
              :checked="visibleCards.hObjectProperties"
            />
          </div>
          <div class="text-center">
            <label for="widgetProperties">Widget properties</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.widgetProperties"
              name="widgetProperties"
              :checked="visibleCards.widgetProperties"
            />
          </div>
          <div class="text-center">
            <label for="cameraProperties">Camera properties</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.cameraProperties"
              name="cameraProperties"
              :checked="visibleCards.CameraProperties"
            />
          </div>
          <div class="text-center">
            <label for="avatarProperties">Avatar properties</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.avatarProperties"
              name="avatarProperties"
              :checked="visibleCards.avatarProperties"
            />
          </div>
          <div class="text-center">
            <label for="codeInspector">Code inspector</label>
            <br />
            <c-switch
              type="text"
              size="sm"
              pill
              variant="success"
              on="On"
              off="Off"
              v-model="visibleCards.codeInspector"
              name="codeInspector"
              :checked="visibleCards.codeInspector"
            />
          </div>
          <div class="text-center">
            <i class="icon-close" @click="home()"></i>
          </div>
        </div>
      </b-card>
      <div class="panelConfiguracionB">
        <div class="contenidoPanelConfiguracionB">
          <b-card
            v-show="visibleCards.hAppsElements"
            class="paddingBottonElement"
          >
            <div slot="header"><strong>hApps</strong> Elements</div>
            <b-form-fieldset label="hApp" :label-cols="3" :horizontal="false">
              <b-form-select
                v-model="hApp_selected"
                :options="hApp_options"
                :plain="true"
                :multiple="false"
                :select-size="7"
              ></b-form-select>
              <button
                v-if="hApp != undefined"
                @click="save_hApp()"
                type="button"
                class="btn btn-success btn-sm"
              >
                <i class="fa fa-floppy-o"></i>
              </button>
              <button
                type="button"
                @click="newhAppModal = true"
                class="btn btn-info btn-sm"
              >
                New hApp
              </button>
            </b-form-fieldset>

            <b-form-fieldset
              label="hObject"
              :label-cols="3"
              :horizontal="false"
            >
              <b-form-select
                v-model="hObject_selected"
                :options="object_options"
                :plain="true"
                :multiple="false"
                :select-size="7"
              ></b-form-select>
              <button
                type="button"
                @click="newhObjectModal = true"
                class="btn btn-info btn-sm"
              >
                New hObject
              </button>
            </b-form-fieldset>
          </b-card>

          <b-card
            v-show="visibleCards.cameraProperties"
            class="paddingBottonElement"
          >
            <div slot="header">
              <strong>Camera properties</strong>
            </div>

            <label for="camera-radius">Radius</label>
            <input
              type="range"
              class="custom-range"
              min="5"
              max="200"
              step="0.5"
              id="camera-radius"
              v-model="camera.radius"
            />

            <label for="camera-heightOffset">Height Offset</label>
            <input
              type="range"
              class="custom-range"
              min="0.5"
              max="200.5"
              step="0.5"
              id="camera-heightOffset"
              v-model="camera.heightOffset"
            />
          </b-card>

          <b-card
            v-show="visibleCards.avatarProperties"
            class="paddingBottonElement"
          >
            <div slot="header">
              <strong>Avatar properties</strong>
            </div>

            <b-form-group>
              <b-row align-h="between">
                <b-col sm="6">
                  <label for="gravity">Gravity</label>
                </b-col>
                <b-col sm="4">
                  <c-switch
                    type="text"
                    size="sm"
                    pill
                    variant="success"
                    on="On"
                    off="Off"
                    v-model="localAvatar.applyGravity"
                    name="gravity"
                    :checked="localAvatar.applyGravity"
                  />
                </b-col>
              </b-row>
              <b-row align-h="between">
                <b-col sm="6">
                  <label for="collisions">Collisions</label>
                </b-col>
                <b-col sm="4">
                  <c-switch
                    type="text"
                    size="sm"
                    pill
                    variant="success"
                    on="On"
                    off="Off"
                    v-model="localAvatar.applyCollisions"
                    name="collisions"
                    :checked="localAvatar.applyCollisions"
                  />
                </b-col>
              </b-row>
            </b-form-group>
          </b-card>

          <HAppsComponent :hApps="this.hScene.hApps" />

          <!-- <HObjectsComponent
            v-for="(hApp, iHObject) in hApps"
            :key="iHObject"
            :hObjects="hApp.content.hObjects"
            :benchedHObjects="hApp.content.hObjects.length"
          /> -->

        </div>
      </div>
      <div class="panelConfiguracionC" v-if="hApp != undefined">
        <div
          class="contenidoPanelConfiguracionC"
          v-show="mostrarPanelConfiguracionC"
        >
          <b-card
            v-show="visibleCards.hAppProperties"
            class="paddingBottonElement"
          >
            <div slot="header">
              <strong>hApp properties</strong>
              {{ hApp['name'] }}
            </div>
            <b-form-fieldset
              label="Name"
              label-size="sm"
              description="hApp name"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input type="text" v-model="hApp['name']"></b-form-input>
            </b-form-fieldset>

            <b-form-group
              vertical
              breakpoint="sm"
              label="Position"
              label-size="sm"
              label-class="font-weight-bold pt-0"
              v-if="hApp.registered"
              class="mb-0"
            >
              <b-input-group size="sm" left="x:">
                <b-form-input
                  id="position-x"
                  type="number"
                  v-model="hApp.content['position'].x"
                ></b-form-input>
              </b-input-group>

              <b-input-group size="sm" left="y:">
                <b-form-input
                  id="position-y"
                  type="number"
                  v-model="hApp.content['position'].y"
                ></b-form-input>
              </b-input-group>

              <b-input-group size="sm" left="z:">
                <b-form-input
                  id="position-z"
                  type="number"
                  v-model="hApp.content['position'].z"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-card>
          <b-card
            v-if="hObject != undefined"
            v-show="visibleCards.hObjectProperties"
            class="paddingBottonElement"
          >
            <div slot="header">
              <strong>hObject properties</strong>
              {{ hObject['name'] }}
            </div>
            <b-form-fieldset
              label="Name"
              label-size="sm"
              description="instance name"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                type="text"
                v-model="hObject['name']"
              ></b-form-input>
            </b-form-fieldset>

            <b-form-group>
              <b-input-group size="sm" left="Type">
                <b-form-input
                  type="text"
                  v-model="hObject['type']"
                  readonly
                ></b-form-input>
              </b-input-group>
              <br />
              <b-row align-h="between">
                <b-col sm="8">
                  <label for="abreviatura">Allow Registration</label>
                </b-col>
                <b-col sm="4">
                  <c-switch
                    type="text"
                    size="sm"
                    pill
                    variant="success"
                    on="On"
                    off="Off"
                    v-model="hObject.allowRegistration"
                    name="activo"
                    :checked="hObject.allowRegistration"
                  />
                </b-col>
              </b-row>
              <b-row align-h="between">
                <b-col sm="8">
                  <label for="abreviatura">Registered</label>
                </b-col>
                <b-col sm="4">
                  <c-switch
                    type="text"
                    size="sm"
                    pill
                    variant="success"
                    on="On"
                    off="Off"
                    v-model="hObject.registered"
                    name="activo"
                    :checked="hObject.registered"
                  />
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group
              vertical
              breakpoint="sm"
              label="Position"
              label-size="sm"
              label-class="font-weight-bold pt-0"
              v-if="hObject.registered"
              class="mb-0"
            >
              <b-input-group size="sm" left="x:">
                <b-form-input
                  id="position-x"
                  type="number"
                  v-model="hObject['position'].x"
                ></b-form-input>
              </b-input-group>

              <b-input-group size="sm" left="y:">
                <b-form-input
                  id="position-y"
                  type="number"
                  v-model="hObject['position'].y"
                ></b-form-input>
              </b-input-group>

              <b-input-group size="sm" left="z:">
                <b-form-input
                  id="position-z"
                  type="number"
                  v-model="hObject['position'].z"
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              vertical
              breakpoint="sm"
              label="Rotation"
              label-size="sm"
              label-class="font-weight-bold pt-0"
              v-if="hObject.registered"
              class="mb-0"
            >
              <b-input-group size="sm" left="x:">
                <b-form-input
                  id="rotation-x"
                  type="number"
                  v-model="hObject['rotation'].x"
                ></b-form-input>
              </b-input-group>

              <b-input-group size="sm" left="y:">
                <b-form-input
                  id="rotation-y"
                  type="number"
                  v-model="hObject['rotation'].y"
                ></b-form-input>
              </b-input-group>

              <b-input-group size="sm" left="z:">
                <b-form-input
                  id="rotation-z"
                  type="number"
                  v-model="hObject['rotation'].z"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <br />
            <b-form-group>
              <b-row align-h="between">
                <b-col sm="8">
                  <label for="abreviatura">Visible</label>
                </b-col>
                <b-col sm="4">
                  <c-switch
                    type="text"
                    size="sm"
                    pill
                    variant="success"
                    on="On"
                    off="Off"
                    v-model="hObject.visible"
                    name="activo"
                    :checked="hObject.visible"
                  />
                </b-col>
              </b-row>
            </b-form-group>
          </b-card>
          <b-card
            v-if="hObject != undefined && widget != undefined"
            v-show="visibleCards.widgetProperties"
            class="paddingBottonElement"
          >
            <div slot="header">
              <strong>Widget properties</strong>
              {{ widget.name }}
            </div>

            <div
              id="widget-images"
              style="display: flex; justify-content: center;"
            >
              <vue-upload-multiple-image
                accept="image/jpeg, image/png, image/gif"
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                :data-images="images"
                dragText="Drag one or more images here  / Arrastre una o varias imágenes aquí"
                browseText="or click to select them / o presione click para seleccionarlas"
                primaryText="Principal / Principal"
                markIsPrimaryText="Set as principal / Elegir como principal"
              ></vue-upload-multiple-image>
            </div>
            {{ getSlug(widget.name) }}-{{ imageIndex }}
            <br />
            <b-form-group
              vertical
              breakpoint="sm"
              label="On Clic event"
              label-size="sm"
              label-class="font-weight-bold pt-0"
              v-if="hObject.registered"
              class="mb-0"
            >
              <b-row align-h="between">
                <b-col sm="8">
                  <label for="abreviatura">Open image(s) in modal</label>
                </b-col>
                <b-col sm="4">
                  <c-switch
                    type="text"
                    size="sm"
                    pill
                    variant="success"
                    on="On"
                    off="Off"
                    v-model="widget.zoom"
                    name="activo"
                    :checked="widget.zoom"
                  />
                </b-col>
              </b-row>

              <label for="widget-title-content">Modal Title</label>
              <b-form-input
                type="text"
                id="widget-title-content"
                v-model="widget.title"
              ></b-form-input>

              <div v-show="!widget.zoom">
                <label for="widget-HTML-content">Modal HTML content</label>
                <textarea
                  class="form-control"
                  id="widget-HTML-content"
                  placeholder="Paste the html code here to embed it"
                  v-model="widget.html"
                  @mouseup="ajustarEditor()"
                ></textarea>
                <button
                  type="button"
                  @click="editWidgetHtml()"
                  class="btn btn-info btn-sm"
                >
                  Edit in inspector code
                </button>
                <br />
                <label for="widget-redirect-url">Redirect to URL</label>
                <b-form-input
                  type="text"
                  id="widget-redirect-url"
                  v-model="widget.url"
                ></b-form-input>
              </div>
            </b-form-group>
          </b-card>

          <HAppPropertiesComponent/>


          <!-- <HAppPropertiesComponent
            v-for="(hApp, iHApp) in hApps"
            :key="iHApp"
            :hApp="hApp"
          /> -->
        </div>
      </div>
    </div>
    <div class="panelConfiguracionD" v-show="visibleCards.codeInspector">
      <div sm="12" v-if="codeInspectorVisible">
        <b-card class="paddingBottonElement marginBottonElement">
          <div slot="header">
            <strong>Code Inspector</strong>
            <button
              class="btn btn-primary pull-right"
              v-b-tooltip.hover
              title="Run"
              @click="codeInspectorRun()"
            >
              <i class="icon-control-play"></i>
            </button>
            <button
              class="btn btn-primary pull-right"
              v-b-tooltip.hover
              title="Undo"
              @click="codeInspectorUndo()"
            >
              <i class="icon-action-undo"></i>
            </button>
          </div>
          <div style="background-color:white">
            <vue-json-editor
              v-model="codeInspector"
              :show-btns="false"
              @json-change="onJsonChange"
            ></vue-json-editor>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal
      title="New hApp"
      class="modal-primary"
      v-model="newhAppModal"
      @ok="new_hApp"
    >
      <b-form-fieldset
        description
        label="hApp name"
        :label-cols="3"
        :horizontal="true"
      >
        <b-form-input type="text" v-model="newhAppName"></b-form-input>
      </b-form-fieldset>
    </b-modal>

    <b-modal
      title="New hObject"
      size="xl"
      class="modal-primary"
      scrollable
      v-model="newhObjectModal"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
    >
      <newHObject></newHObject>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router/index.js'
import HApp from '@/core/HApp.js'
import HObject from '@/core/HObject.js'
import cSwitch from '@/components/Switch'
import HAppsComponent from '@/components/HApp/Index'
import HAppPropertiesComponent from '@/components/HApp/Properties'
import HObjectsComponent from '@/components/HObject/Index'

import newHObject from './NewHObject'
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

import vueJsonEditor from 'vue-json-editor'
import PictureInput from 'vue-picture-input'
import VueUploadMultipleImage from 'vue-upload-multiple-image'

export default {
  name: 'editor',
  components: {
    cSwitch,
    vueJsonEditor,
    newHObject,
    PictureInput,
    VueUploadMultipleImage,
    HAppsComponent,
    HAppPropertiesComponent,
    HObjectsComponent
  },
  data() {
    return {
      visibleCards: {
        hAppsElements: true,
        hAppProperties: true,
        hObjectProperties: true,
        widgetProperties: true,
        cameraProperties: false,
        avatarProperties: false,
        codeInspector: false
      },
      codeInspector: '',
      codeInspectorVisible: true,
      codeInspectorTarget: null,
      usuario: null,
      mostrarPanelConfiguracionC: false,
      benchedhApps: 0,
      hApps: [],
      itemHApps: null,
      hApp_selected: null,
      hApp_options: [],
      hApp: undefined,
      hObject_selected: null,
      object_options: [],
      hObject: {
        name: '',
        position: { x: 0, y: 0, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        updateMeshesPositionRotation() {}
      },
      widget_selected: null,
      widget: undefined,
      newhAppName: '',
      newhAppModal: false,
      newhObjectModal: false,
      arrayImageIndex: [{ value: '1' }],
      imageIndex: 1,
      camera: { radius: 5, heightOffset: 0.5 },
      localAvatar: { applyGravity: true, applyCollisions: true },
      images: []
    }
  },
  mounted: function() {
    for (let key in this.hScene.hApps) {
      this.hApp_options.push({ text: key, value: key })
    }

    this.hApps = this.hApp_options.map(({ value }) => {
      const content = JSON.parse(JSON.stringify(this.hScene.hApps[value]))
      return content
    })

    // console.log(this.hScene.hApps)
    // console.log(this.hApp_options)
    // console.log('Editor')
    // console.log(this.hApps)

    if (!this.hApp_options.length) {
      this.home()
    }
    this.usuario = JSON.parse(
      sessionStorage.getItem('datos_usuario_autenticado')
    )
    // this.camera = window.environment.camera

    EventBus.$on('newHObjectTypeEvent', obj => {
      this.new_hObject(obj.newhObjectName, obj.hObjectType)
      this.newhObjectModal = false
    })

    EventBus.$on('selectEvent', obj => {
      let h = obj.name.split('.')
      this.hApp_selected = h[0]
      let _this = this

      // Se debe dar tiempo a que se cargue object_options según el hApp_selected par que se pueda buscar y asignar el hObject_selected
      setTimeout(() => _this.selectHObjectByName(h[1]), 500)
      setTimeout(() => _this.selectWidgetByName(obj.name), 700)
    })

    if (document.getElementsByClassName('container-fluid')[0]) {
      new ResizeObserver(this.ajustarEditor).observe(
        document.getElementsByClassName('container-fluid')[0]
      )
    }

    if (document.getElementsByClassName('panelConfiguracionC')[0]) {
      new ResizeObserver(this.ajustarEditor).observe(
        document.getElementsByClassName('panelConfiguracionC')[0]
      )
    }

    if (document.getElementsByClassName('panelConfiguracionD')[0]) {
      new ResizeObserver(this.ajustarEditor).observe(
        document.getElementsByClassName('panelConfiguracionD')[0]
      )
    }
  },
  updated: function() {
    this.ajustarEditor()
  },
  watch: {
    hApp_selected: function(evt) {
      this.hObject = undefined
      this.hObject_selected = null
      this.object_options = []
      this.hApp = this.hScene.hApps[evt]

      for (let index in this.hApp.content['hObjects']) {
        this.object_options.push({
          value: index,
          text: this.hApp.content['hObjects'][index].name
        })
      }
      this.codeInspector = this.hApp
    },
    hObject_selected: function(evt) {
      if (evt) {
        this.hObject = this.hApp.content.hObjects[evt]
        // this.codeInspector = this.hObject
      }
    },
    // Si cambian las propiedades del hApp
    'hApp.content.position.x': function() {
      this.hApp.updateMeshesPositionRotation()
    },
    'hApp.content.position.z': function() {
      this.hApp.updateMeshesPositionRotation()
    },
    'hApp.content.position.y': function() {
      this.hApp.updateMeshesPositionRotation()
    },
    // Si cambian las propiedades del hObject
    'hObject.position.x': function() {
      this.hObjectUpdateMeshesPositionRotation()
    },
    'hObject.position.z': function() {
      this.hObjectUpdateMeshesPositionRotation()
    },
    'hObject.position.y': function() {
      this.hObjectUpdateMeshesPositionRotation()
    },
    'hObject.rotation.x': function() {
      this.hObjectUpdateMeshesPositionRotation()
    },
    'hObject.rotation.z': function() {
      this.hObjectUpdateMeshesPositionRotation()
    },
    'hObject.rotation.y': function() {
      this.hObjectUpdateMeshesPositionRotation()
    },
    'hObject.registered': function() {
      if (this.hObject) {
        if (this.hObject.registered) {
          this.hScene.registerHObject(this.hObject, true)
        } else {
          this.hScene.unRegisterHObject(this.hObject, true)
        }
      }
    },
    'camera.radius': function() {
      window.environment.camera.radius = this.camera.radius
    },
    'camera.heightOffset': function() {
      window.environment.camera.heightOffset = this.camera.heightOffset * 1
    },
    'localAvatar.applyGravity': function() {
      window.environment.localAvatar.applyGravity = this.localAvatar.applyGravity
    },
    'localAvatar.applyCollisions': function() {
      window.environment.localAvatar.applyGravity = this.localAvatar.applyCollisions
    },
    'widget.numImages': function() {
      this.arrayImageIndex = []
      for (let i = 1; i <= this.widget.numImages; i++) {
        this.arrayImageIndex.push({ value: i })
      }
    }
  },
  computed: {
    ...mapState(['hScene'])
  },
  methods: {
    home() {
      router.push({
        name: 'home'
      })
    },
    ajustarEditor() {
      let posicionLeftPanelA =
        document.getElementsByClassName('panelConfiguracionA').length > 0
          ? document.getElementsByClassName('panelConfiguracionA')[0].offsetLeft
          : 0
      let posicionTopPanelA =
        document.getElementsByClassName('panelConfiguracionA').length > 0
          ? document.getElementsByClassName('panelConfiguracionA')[0].offsetTop
          : 0
      let anchoPanelA =
        document.getElementsByClassName('panelConfiguracionA').length > 0
          ? document.getElementsByClassName('panelConfiguracionA')[0]
              .offsetWidth
          : 0
      let altoPanelB =
        document.getElementsByClassName('panelConfiguracionB').length > 0
          ? document.getElementsByClassName('panelConfiguracionB')[0]
              .offsetHeight
          : 0
      let anchoPanelC =
        document.getElementsByClassName('panelConfiguracionC').length > 0
          ? document.getElementsByClassName('panelConfiguracionC')[0]
              .offsetWidth
          : 0
      let altoPanelC =
        document.getElementsByClassName('panelConfiguracionC').length > 0
          ? document.getElementsByClassName('panelConfiguracionC')[0]
              .offsetHeight
          : 0
      let altoPanelD =
        document.getElementsByClassName('panelConfiguracionD').length > 0
          ? document.getElementsByClassName('panelConfiguracionD')[0]
              .offsetHeight
          : 0
      let medidaMayorHeightPanelConfiguracionAB =
        altoPanelB > altoPanelC ? altoPanelB : altoPanelC

      // Calcular el panel B
      if (document.getElementsByClassName('panelConfiguracionB').length > 0) {
        document.getElementsByClassName(
          'panelConfiguracionB'
        )[0].style.left = `${posicionLeftPanelA}px`
        document.getElementsByClassName(
          'panelConfiguracionB'
        )[0].style.top = `${posicionTopPanelA + 80}px`
      }

      // Calcular el panel C
      if (document.getElementsByClassName('panelConfiguracionC').length > 0) {
        document.getElementsByClassName(
          'panelConfiguracionC'
        )[0].style.top = `${posicionTopPanelA + 80}px`
        document.getElementsByClassName(
          'panelConfiguracionC'
        )[0].style.left = `${posicionLeftPanelA + anchoPanelA - anchoPanelC}px`
      }

      // Calcular el panel D
      if (document.getElementsByClassName('panelConfiguracionD').length > 0) {
        document.getElementsByClassName(
          'panelConfiguracionD'
        )[0].style.left = `${posicionLeftPanelA}px`
        document.getElementsByClassName(
          'panelConfiguracionD'
        )[0].style.width = `${anchoPanelA}px`
        document.getElementsByClassName(
          'panelConfiguracionD'
        )[0].style.top = `${posicionTopPanelA +
          medidaMayorHeightPanelConfiguracionAB +
          100}px`

        document.getElementsByClassName(
          'app'
        )[0].style.height = `${posicionTopPanelA +
          medidaMayorHeightPanelConfiguracionAB +
          altoPanelD +
          250}px`
        document.getElementsByClassName(
          'main'
        )[0].style.height = `${posicionTopPanelA +
          medidaMayorHeightPanelConfiguracionAB +
          altoPanelD +
          600}px`
      }

      this.mostrarPanelConfiguracionC = true
    },
    onJsonChange(value) {
      // console.log('value:', value)
    },
    hObjectUpdateMeshesPositionRotation() {
      if (this.hObject) {
        this.hObject.updateMeshesPositionRotation()
      }
    },
    selectHObjectByName(name) {
      if (this.object_options !== undefined && this.object_options.length) {
        this.hObject_selected = this.object_options.find(
          x => x.text === name
        ).value
      }
    },
    selectWidgetByName(name) {
      if (this.object_options !== undefined && this.object_options.length) {
        this.widget_selected = this.hObject.getIndexWidgetByName(name)
        if (this.widget_selected > 0) {
          this.widget = this.hObject.widgets[this.widget_selected]
        }
      }
    },
    save_hApp() {
      console.log('save_hApp')
      console.log(this.hApp)
      if (this.hApp.id === undefined) {
        this.hScene.postHApp(this.hApp)
      } else {
        // this.hScene.putHApp(this.hApp)
      }
    },
    new_hApp() {
      // Create new hApp and register in hScene
      this.hApp = new HApp(this.newhAppName)
      if (typeof window.environment.localAvatar !== 'undefined') {
        // Ubicación del nuevo hApp según la posición de localAvatar
        this.hApp.content.position.x = Math.round(
          window.environment.localAvatar.position.x
        )
        this.hApp.content.position.z = Math.round(
          window.environment.localAvatar.position.z
        )
        this.hApp.content.position.y = Math.round(
          window.environment.localAvatar.position.y
        )
        // console.log(window.environment.localAvatar)
      }
      this.hApp.dimension = window.dimension
      this.hApp.user_email = this.usuario.correo_electronico
      this.hScene.registerHApp(this.hApp)

      // Add hApp in editor
      this.hApp_options.push({
        text: this.newhAppName,
        value: this.newhAppName
      })
      this.hApp_selected = this.newhAppName

      // Reset Form new hApp
      this.newhAppModal = false
      this.newhAppName = ''
    },
    new_hObject(newhObjectName, hObjectType) {
      if (
        typeof window.environment.localAvatar !== 'undefined' &&
        this.hApp !== undefined
      ) {
        this.hObject = new HObject(newhObjectName, hObjectType, true)

        // Ubicación del nuevo hObject según la posición de localAvatar y "relativo" a la posición del hApp
        this.hObject.position.x =
          Math.round(window.environment.localAvatar.position.x) -
          this.hApp.content.position.x
        this.hObject.position.z =
          Math.round(window.environment.localAvatar.position.z) -
          this.hApp.content.position.z
        this.hObject.position.y =
          Math.round(window.environment.localAvatar.position.y) -
          this.hApp.content.position.y

        this.hApp.addHObject(this.hObject)
        this.hScene.registerHObject(this.hObject)

        // Add hApp in editor
        this.object_options.push({
          value: this.object_options.length,
          text: this.hObject.name
        })
        this.hObject_selected = this.object_options.length - 1
      }
    },
    codeInspectorUndo() {},
    codeInspectorRun() {
      this.hScene.unRegisterHObjects(this.hApp)
      this.hObject = null

      // let newhObject = JSON.parse(this.codeInspector)
      let newhObject = this.codeInspector
      newhObject.registered = false
      this.hApp.content.hObjects[newhObject.name] = newhObject
      this.hScene.registerHObjects(this.hApp)

      this.hObject = this.hApp.content.hObjects[newhObject.name]
    },
    onChangedImage() {
      // if (this.$refs.file_avatar[0].file) {
      //   this.createInput(this.$refs.file_avatar[0].file)
      // }
    },
    onRemovedImage() {
      // this.usuario.ruta_imagen_usuario = 'personalizado.png'
      // this.imagen_avatar = null
    },
    uploadImageSuccess(formData, index, fileList) {
      // console.log('data', formData, index, fileList)
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(index, done, fileList) {
      // console.log('index', index, fileList)
      const r = confirm('remove image')
      if (r == true) {
        done()
      } else {
      }
    },
    editImage(formData, index, fileList) {
      // console.log('edit data', formData, index, fileList)
    },
    editWidgetHtml() {
      // this.visibleCards.codeInspector = true
    },
    getSlug(str) {
      str = str.toLowerCase()
      return str.replace(/ /g, '-')
    }
  }
}
</script>

<style scoped>
.contenedor {
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.panelesConfiguracion {
  width: 100%;
}

.panelConfiguracionA {
  width: 100%;
  height: 60px;
}

.contenidoPanelConfiguracionA {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.panelConfiguracionB {
  width: 200px;
  position: absolute;
  top: 0;
  left: 0;
}

.contenidoPanelConfiguracionB {
  display: block;
}

.panelConfiguracionC {
  width: 220px;
  position: absolute;
  top: 0;
  right: 0;
}

.contenidoPanelConfiguracionC {
  display: block;
}

.panelConfiguracionD {
  position: absolute;
  top: 0;
  left: 0;
}

#widget-images {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  margin-bottom: 10px;
}

.paddingBottonElement {
  padding-bottom: 20px !important;
}

.marginBottonElement {
  margin-bottom: 20px !important;
}

.card-body,
.card-block {
  padding: 0 0.55rem 0 0.55rem;
}

.form-group {
  margin-bottom: 0.4rem;
}

.card {
  font-size: 0.675rem !important;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.text-muted {
  color: #aaa !important;
}

.card-header {
  background-color: rgba(0, 0, 0, 0.2);
  background-color: none;
  border-bottom: 1px solid #626f76;
}

.form-input-fieldset {
  margin-top: 0.175rem;
}

.form-control {
  padding: 0.175rem 0.75rem;
  font-size: 0.675rem;
  line-height: 1.2;
  color: white;
  background-color: rgba(0, 0, 0, 0.4);
  border: none;
}

.input-group-addon {
  padding: 0.175rem 0.75rem;
  line-height: 1.2;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Editor/Editor.vue